import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { FlagFr, FlagEn, FlagDe } from 'data/common/iconsvg';

class TableUsersManager extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        UsersManagers: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/user-manager/detail/${rowData.id}` });
    };

    renderData = memoizeOne(UsersManagers => {
        const { history } = this.props;
        let result = [];

        UsersManagers.map((userManager, userManagerId) => {
            result.push({
                id: parseInt(userManagerId),
                email: userManager.get('email'),
                firstname: userManager.get('firstname'),
                lastname: userManager.get('lastname'),
                role: userManager.get('role') ? Translator.translate(`generic.userManager.table.${userManager.get('role')}`) : '',
                lang: userManager.get('lang')
            });
        });

        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('userManagerDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderColumns = memoizeOne(profile => {
        const { history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.identifier'),
                name: 'id',
                defaultSort: 'asc'
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('userManagerDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.firstname'),
                name: 'firstname'
            },
            {
                title: Translator.translate('general.table.column.lastname'),
                name: 'lastname'
            },
            {
                title: Translator.translate('general.table.column.role'),
                name: 'role'
            },
            {
                title: Translator.translate('general.table.column.lang'),
                name: 'lang',
                render: (row, data, value) => {
                    let res = null;
                    switch (value) {
                        case 'fr_FR':
                            res = <FlagFr />;
                            break;
                        case 'de_DE':
                            res = <FlagDe />;
                            break;
                        case 'en_EN':
                            res = <FlagEn />;
                            break;
                    }
                    return res;
                }
            }
        ];
    });

    renderTable() {
        const { UsersManagers, profile } = this.props;

        return (
            <FHETable
                idTable="managementDetailUserManager"
                columns={this.renderColumns(profile)}
                data={this.renderData(UsersManagers)}
                actions={this.renderActions(profile)}
                minified
            />
        );
    }

    render() {
        const { UsersManagers, theme, history } = this.props;
        return (
            <Fragment>
                {UsersManagers.size > 0 ? (
                    this.renderTable()
                ) : (
                    <div style={{ color: theme.palette.text.primary }}>
                        {Translator.translate(`generic.userManager.table.body.emptyDataSourceMessage`)}
                    </div>
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { managementId, history } = props;
    const UsersManagers = state.environments[history.environment].data.UsersManagers.get('list').filter(UserManager => {
        if (UserManager.get('managementIds')) {
            return UserManager.get('managementIds').includes(managementId);
        }
    });

    return {
        profile: state.data.user,
        UsersManagers
    };
}

const styles = theme => ({
    enabled: {
        color: theme.palette.success.main
    },
    disabled: {
        color: theme.palette.error.main
    }
});
export default withRouter(
    renderEnvComponent(
        'scenes/Management/Table/TableUsersManager',
        connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableUsersManager))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/Table/TableUsersManager.js